export const GAME = {
    WIDTH: 1280,
    HEIGHT: 800,
    CENTER_X: 640,
    CENTER_Y: 400,
    // Tela mais larga que 16:10 (celular): o canvas ganha largura e a área de 1280 fica centrada.
    // Fundos e faixas são desenhados até `MARGEM` além de cada lado, para cobrir até o teto.
    MARGEM: 320,
    LARGURA_TOTAL: 1920
};

export const LAYOUT = {
    CONTENT_LEFT: 120,
    CONTENT_WIDTH: 1040,
    HEADER_Y: 60,
    FRAME_UP_Y: 120,
    FRAME_DOWN_Y: 740,
    FOOTER_Y: 765
};

export const SCENES = {
    BOOT: 'Boot',
    PRELOADER: 'Preloader',
    MAIN_MENU: 'MainMenu',
    LOGIN: 'Login',
    AGUARDE: 'Aguarde',
    EM_BREVE: 'EmBreve',
    MATERIAIS: 'Materiais',
    MURAL: 'MuralInsights',
    RANKING: 'Ranking',
    SCAN_RESULTADO: 'ScanPixelResultado',
    LAB_RESULTADO: 'LabPixelsResultado',
    PLAYER1: 'Player1',
    PLAYER1_RESULTADO: 'Player1Resultado',
    VERSUS: 'Versus',
    VERSUS_ARGUMENTO: 'VersusArgumento',
    VERSUS_RESULTADO: 'VersusResultado',
    GAME_OVER: 'GameOver',
    GAME: 'Game',
    QUIZ: 'Quiz',
    BOSS_FINAL: 'BossFinal',
    TELA_ESPERA_TELAO: 'TelaEsperaTelao',
    ESTACAO_LOGIN: 'EstacaoLogin',
    ESTACAO: 'Estacao',
    ESTACAO_MENU_RESOLUCAO: 'EstacaoMenuResolucao',
    MENU_RESOLUCAO: 'MenuResolucao'
};

export const TEX = {
    BG: 'bg_fundo',
    BG_GRAFITE: 'bg-grafite',
    LOGO_FIAT_ARCADE: 'logo-fiat-arcade',
    LOGO_ARGO_X: 'logo-argo-x',
    ICON_POST_IT: 'icon-post-it',
    ICON_MATERIAIS: 'icon-materiais',
    ICON_TROFEU: 'icon-trofeu',
    BG_LIMA: 'bg-lima',
    PASTA_ABERTA: 'pasta-aberta',
    PASTA_BLOQUEADA: 'pasta-bloqueada',
    TROFEU_OURO: 'trofeu-ouro',
    TROFEU_PRATA: 'trofeu-prata',
    TROFEU_BRONZE: 'trofeu-bronze',
    ICON_LIXEIRA: 'icon-lixeira',
    BTN_INSIGHTS_REDONDO: 'btn-insights-redondo',
    BTN_MATERIAIS_PILULA: 'btn-materiais-pilula',
    BTN_MATERIAIS_MINI: 'btn-materiais-mini',
    LOGO_ARGO_X_BRANCO: 'logo-argo-x-branco',
    LIVRO_MAIS_UM: 'livro-mais-um',
    ICON_INFO_PIXEL: 'icon-info-pixel',
    P1_CLIENTE_NEUTRO: 'p1-cliente-neutro',
    P1_CLIENTE_CELULAR: 'p1-cliente-celular',
    P1_CLIENTE_DESCONFIADO: 'p1-cliente-desconfiado',
    P1_CLIENTE_PENSATIVO: 'p1-cliente-pensativo',
    P1_CLIENTE_PREOCUPADO: 'p1-cliente-preocupado',
    P1_CLIENTE_FELIZ: 'p1-cliente-feliz',
    P1_ICON_FIDELIZACAO: 'p1-icon-fidelizacao',
    P1_ICON_CONFIANCA: 'p1-icon-confianca',
    P1_ICON_AGILIDADE: 'p1-icon-agilidade',
    P1_ICON_CONEXAO: 'p1-icon-conexao',
    P1_ICON_LAMPADA: 'p1-icon-lampada',
    VS_CLIENTE_MARCOS: 'vs-cliente-marcos',
    VS_CLIENTE_FERNANDA: 'vs-cliente-fernanda',
    VS_FOTO_MARCOS: 'vs-foto-marcos',
    VS_FOTO_FERNANDA: 'vs-foto-fernanda',
    VS_BTN_ENVIAR: 'vs-btn-enviar',
    VS_BTN_FECHAR: 'vs-btn-fechar',
    LOGO: 'logo',
    LOGO_SCAN: 'logo_scan_pixel',
    LOGO_LAB: 'lab-pixel-logo',
    FRAME_UP: 'frame-up',
    FRAME_DOWN: 'frame-down',
    FRAME_PIXEL: 'frame-pixel',
    FRAME_MODAL: 'frame-modal-double-pixel',
    FRAME_CARD: 'frame-card-default',
    BTN_ACTIVE: 'button-active',
    BTN_DISABLE: 'button-disable',
    BTN_MODAL: 'button-begin-modal',
    BTN_HOME: 'button-inicio-scan',
    BTN_MATERIAIS: 'button-materiais',
    BTN_CONFIRM_ACTIVE: 'button-confirmar-lab-active',
    BTN_CONFIRM_DISABLE: 'button-confirmar-lab-disable',
    ICON_INFO: 'icon-info',
    ICON_TIMER: 'icon-timer',
    ICON_BOOK: 'icon-book-liberado',
    LOCK_OPEN: 'cadeado-aberto',
    LOCK_CLOSED: 'cadeado-fechado',
    // Menu Resolução (jogador)
    LOCK_RESULTADO: 'menu-resolucao-cadeado',
    MR_CONSOLE: 'menu-resolucao-console',
    MR_PRESENTE: 'menu-resolucao-presente',
    FAC_ENGRENAGEM: 'menu-resolucao-engrenagem'
};

export const EVENTS = {
    MODAL_OPEN: 'modal:open',
    MODAL_CLOSE: 'modal:close'

};
